export class RunAtOutOfRangeError extends Error {
    constructor() {
        super('Job attempted to be created in the past.');
        this.name = 'RunAtOutOfRangeError';
    }
}
